import styled from 'styled-components';

export const Div = styled.div`
  position: relative;
  bottom: 16px;

  .gray_text {
    color: rgba(0, 0, 0, 0.7);
  }

  .main_info {
    grid-row: 2 / span 2;
    align-self: center;
    margin-left: 10%;
    margin-top: 24px;
  }

  .description {
    font-size: 11px;
  }

  .viewer {
    position: absolute;
    left: 32px;
    top: 53%;
    font-size: 10px;
    transform: translateY(-50%);
    text-align: center;
  }

  .data_viewer {
    font-size: 17px;
    font-weight: 400;
    margin-bottom: 0;
  }

  .canvas {
    grid-row: 1 / span 3;

    canvas {
      width: 90px;
      height: 90px;
    }
  }

  .description_charged {
    font-size: 18px;
    color: #3a89ff;
    margin: 0;
    padding-left: 8px;
  }

  .indicators--pie {
    z-index: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    left: 25px;
    top: 9px;
    width: 70px;
    height: 70px;
  }

  .indicators--pie-text {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .number_registered--text {
    font-size: 18px;
    justify-self: flex-end;
    color: #333;
  }
`;

export const Wrapper = styled.div`
  width: 120px;
  height: 90px;
  position: relative;
`;

const WrapperIcon = styled.div`
  font-size: 30px;
  justify-self: flex-end;
  font-weight: 600;
`;

export const WrapperStationIcon = styled(WrapperIcon)`
  margin-left: 8px;
  color: #EA4235;
`;

export const WrapperSustainabilityIcon = styled(WrapperIcon)`
  color: #78d78d;
`;
